import { buildI18n } from "go-core/utils/i18nUtils";

const version = "1.0.3";
const cdnUrlTranslation = null;
//"https://delivery.localazy.com/_a797943615975789155479c22487/_e0/a32549b8b99f00080ddf2c2f5fa42f8e816191e1";
const cdnUrlAdmin = null;
// "https://delivery.localazy.com/_a797943615975789155479c22487/_e0/1fdea2a0f23b7d793a9e364ab9b226317e8c6cad";
const cdns = {
	translation: cdnUrlTranslation,
	admin: cdnUrlAdmin,
};
let i18n = buildI18n(version, cdns, ["admin"], false, ["pl", "en", "de"]);
export default i18n;
